import Vue from 'vue'
import VueCookies from 'vue-cookies'

import 'jquery'

import App from './App.vue'

import i18n from './i18n.js'
import router from './routes.js'

import './fontAwesome.js'

import './assets/css/main.scss'

Vue.config.productionTip = false

Vue.use(VueCookies)

Object.defineProperty(Vue.prototype, '$locale', {
  get: function() {
    i18n.locale = Vue.$cookies.get('locale');
    return i18n.locale
  },
  set: function(locale) {
    i18n.locale = locale
    Vue.$cookies.set('locale', i18n.locale)
  }
})

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
